<template>
  <CartCheckoutWrapper>
  <section class="checkout-wrapper">
    <div class="container-fluid">
      <form  novalidate
            class="checkout-form inputs-border inputs-bg" @submit.prevent="onSubmit">
        <div class="row">

        <div class="col-sm-12 col-lg-6">
            <div class="alert alert-info" v-if="showLoginLink">
              <strong>Returning customer?</strong> <a href="#" class="effect"
                data-slide-toggle=".checkout-login-form" @click="showLogin = !showLogin">
                Click here to Login</a>
            </div>
          </div>
          <div class="col-sm-12 col-lg-6"></div>
          <div class="col-sm-12 col-lg-6">
            <div v-if="!user">
              <div class="checkout-login-form box" v-if="showLogin && !loggedIn">
                <ReturningCustomerLogin />
              </div>
            </div>

          </div>
          <div class="col-lg-6"></div>
          <div class="clearfix"></div>

          <div fromGroupName="shipping_address" class= "col-sm-12 col-lg-6">
            <CustomerInfo info-type="Shipping" v-model="shipping"/>
            <div v-if="flags.debugTools && shippingAddressVerification">
              <pre class="debug-data">{{ shippingAddressVerification }}</pre>
            </div>

        <!-- remove create account option

            <div class="form-group" v-if="showCreateAccountOption">
              <input type="checkbox" id="create_account" v-model="showCreateAccount">
              <label for="create_account" class="checkbox" data-slide-toggle=".create-account">Create an account?</label>
              <div class="create-account box" v-if="showCreateAccount">
                <p>
                  Create an account by entering the information below. If you are a returning customer please login at the top of the page.
                </p>
                <div class="form-group">
                  <input formControlName="password" type="password" class="form-control" placeholder="Account Password">
                </div>
              </div>
            </div> -->



            <div class="form-group" v-if="needsPayment">
              <h3>
                <input type="checkbox" id="billing-different-address" v-model="billing_different_address"><!--ANGULAR: (change)="onBillingCheckboxChange($event)"-->
                <label for="billing-different-address" class="checkbox"
                       data-slide-toggle=".different-address">Different billing address?</label>
              </h3>
              <CustomerInfo info-type="Billing" v-model="billing" v-if="billing_different_address"></CustomerInfo>
            </div>

          </div>

          <div class="col-sm-12 col-lg-6">
            <div class="review-order">
              <div class="box">
                <BasketSummary/>
                <CheckoutPayment v-if="needsPayment" v-model="payment"/>
                <CheckoutReviewSettings/>
                <div class="text-right place-order-buttons">
                  <div @mouseover="onMouseOver">
                    <WaveSpinner inline v-if="busy"/>
                    <button :disabled="busy || !paymentInfoComplete || !isShippingAddressValid" class="btn-action">
                      {{busy ? 'Placing Order...' : 'Place Order'}}  <i class="fa fa-arrow-right"></i>
                    </button>
                  </div>
                  <OrderReviewMessage v-model="skip_review" />


                </div>
                <ul class="error" v-if="checkoutErrors.length">
                  <li v-for="err in checkoutErrors" :key="err">{{err}}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </section>
  </CartCheckoutWrapper>
</template>
<script>
  import CustomerInfo from './CustomerInfo';
  import BasketSummary from '../basket/BasketSummary';
  import CheckoutPayment from './CheckoutPayment'
  import ReturningCustomerLogin from './ReturningCustomerLogin'
  import CheckoutReviewSettings from './CheckoutReviewSettings';
  import OrderReviewMessage from "./OrderReviewMessage";

  import {ADDRESS_TYPE_VERIFY, empty_payment, isAddressComplete} from '@/lib/CheckoutLogic';

  import {mapActions, mapGetters, mapMutations} from 'vuex';

  export default{
    components:{
      CustomerInfo,
      BasketSummary,
      CheckoutPayment,
      ReturningCustomerLogin,
      CheckoutReviewSettings,
      OrderReviewMessage
    },
    data(){
      return {
        user: false,
        payment: empty_payment(),
        showLogin: false,
        showCreateAccount: false,
        showIssues: false,
        verifying: false
      }
    },
    methods:{
      ...mapActions([
        'updateCheckoutInfo', 'loadStripe', 'updatePaymentInfo', 'placeOrder', 'calcTax', 'loadSavedCards',
        'verifyShippingAddressData', 'setDefaultCheckoutInfo',
      ]),
      ...mapMutations(['removeShippingAddressVerification']),
      onSubmit(){
        this.showIssues = true;
        this.placeOrder();
      },
      onMouseOver() {
        this.showIssues = true;
      }
    },
    computed: {
      ...mapGetters(['checkoutInfo', 'loggedIn', 'orderInfo',
        'paymentInfoComplete', 'checkoutIssues', 'checkoutBusy',
        'needsPayment', 'hasCardOnFile', 'canSaveCardOnFile',
        'flags', 'shippingAddressVerification','isShippingAddressValid']),
      billing: checkoutAccessor('billing'),
      shipping: checkoutAccessor('shipping'),
      skip_review: checkoutAccessor('skip_review'),
      copiedShipping() {
        // We want to verify address each time it changes. But we cannot use `shipping` directly in `watch`
        // because of `Vue` limitations for mutated Objects/Arrays (https://vuejs.org/v2/api/#vm-watch).
        // `copiedShipping` is a workaround for this case (it is used in `watch`).
        return {...this.shipping}
      },
      billing_different_address: checkoutAccessor('billing_different_address'),
      checkoutErrors() {
        return this.showIssues ? this.checkoutIssues : [];
      },
      busy() {
        return this.checkoutBusy;
      },
      showLoginLink() {
        return !this.loggedIn;
      },
      showCreateAccountOption() {
        return !this.loggedIn;
      }
    },
    watch: {
      loggedIn(newVal, oldVal) {
        console.log('loggedIn changed:', newVal, oldVal);
      },
      checkoutErrors(val) {
        // If any errors mention tax, try to fix
        if (val && val.find(s => /tax/i.test(s))) {
          this.calcTax();
        }
      },
      payment: {
        deep: true,
        handler(value) {
          this.updatePaymentInfo(value);
        }
      },
      orderInfo: {
        deep: true,
        handler(value) {
          if (value.placed) {
            this.$router.push('/invoice');
          }
        }
      },
      async copiedShipping(newVal, oldVal) {
        if (this.flags.verifyCheckoutShippingAddressData && isAddressComplete(newVal, ADDRESS_TYPE_VERIFY)) {
          // For address verification we are care only about "address related" fields
          const isCountryChanged = newVal.country !== oldVal.country;
          const isLine1Changed = newVal.line1 !== oldVal.line1;
          const isLine2Changed = newVal.line2 !== oldVal.line2;
          const isPostcodeChanged = newVal.postcode !== oldVal.postcode;
          const isCityChanged = newVal.city !== oldVal.city;
          const isStateChanged = newVal.state !== oldVal.state;
          const isMainDataChanged = (
            isCountryChanged || isLine1Changed || isLine2Changed || isPostcodeChanged || isCityChanged || isStateChanged
          )
          if (isMainDataChanged) {
            this.removeShippingAddressVerification();
            this.verifying = true;
            await this.verifyShippingAddressData(newVal);
            this.verifying = false;
          }
        }
      }
    },
    mounted() {
      this.loadStripe();
      this.setDefaultCheckoutInfo();
    }
  }

  function checkoutAccessor(field) {
    return {
      get() {
        return this.checkoutInfo[field];
      },
      set(value) {
        this.updateCheckoutInfo({...this.checkoutInfo, [field]: value});
      }
    }
  }
</script>

<style scoped lang="scss">
@import '~scss/colors';

  .place-order-buttons {
    padding: 10px;
    button.btn {
      padding-top: 0;
    }
  }

  .error {
    color: $alert-red;
    font-weight: bold;
    background-color: $alert-pink;
  }
  .order-notes{   /* notes section removed from html */
    height:200px;
  }
  .checkout-wrapper {
    background-color:$gray-3;

    form .title {
      margin-bottom: 200px;
      margin-top: 0;
    }

    .form-group {
      margin-bottom: 20px;
    }

    .inputs-border.inputs-bg .form-control {
      border-color:red;
    }

    .inputs-bg {
      .form-control {
        background-color: $white !important;
      }
    }

    .inputs-border {
      .form-control {
        border-bottom: 1px solid #EEE;

        &:focus {
          border-bottom-color: get-theme-color('accent');
        }
      }
    }

    .debug-data {
      text-align: left;
      font-size: small;
      border: 1px dashed blue;
    }

  }
</style>
<style lang="scss">
// non-scoped styles intended to apply the "label-in-input" look
.checkout-wrapper {
  max-width:1100px;
  margin: 0 auto;
  .form-group:not(.no-label-css) {
    position: relative;
    top: auto;
    left: auto;
    width: auto;

    label:not(.checkbox)
    {
      position: absolute;
      top: 6px;
      left:10px;
      z-index: 1;
      font-size: 14px;
      white-space: nowrap;
      transition: all .2s ease;
      color: rgba(#8D8D8D, .5);
      height: 43px;
      line-height: 2em;
      font-weight: normal;
      cursor: text;
    }
    input.form-control {
      padding: 0.7rem 0.75rem 0.3rem 0.75rem;
    }
    input:focus ~ label:not(.checkbox),
    input:valid:not(.ng-pristine) ~ label:not(.checkbox)
    {
      font-size: 10px;
      font-weight: 300;
      left: 14px;
      top: -3px;
      color: get-theme-color('accent');
    }
  }

  input.ng-invalid:not(.ng-pristine), select.ng-invalid:not(.ng-pristine)  {
    border-left: 5px solid #e74c3c;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/checkout/Checkout.vue